import React from 'react';
import { durumEtiketSinifi, durumAdi } from '../yardimcilar';

export default function DurumEtiketi({ durum, ad }) {
  return (
    <span className={`status-badge ${durumEtiketSinifi(durum)}`}>
      {durumAdi(durum, ad)}
    </span>
  );
}
